import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import ViaplayLiveFeed from './ViaplayLiveFeed';
import ViasportLiveFeed from './ViasportLiveFeed';
import BroadcastAreaFeed from './BroadcastAreaFeed';
import LongformFeed from './LongformFeed';
import translatedRoutes from '../../config/translatedRoutes';

const templates = {
  one: [
    'BroadcastAreaFeed',
    'LongformFeed',
  ],
  two: [
    'BroadcastAreaFeed',
    'LongformFeed',
  ],
  thee: [
    'BroadcastAreaFeed',
    'LongformFeed',
  ],
  four: [
    'LongformFeed',
    'BroadcastAreaFeed',
  ],
};

const mapStateToProps = state =>({
  language: state.language,
  country: state.country,
  articlePageRoute: translatedRoutes[state.country].ArticlePage,
  broadcastAreaData: state.broadcastAreaData,
});

@connect(mapStateToProps)
export default class BroadcastArea extends React.PureComponent {

  getItems(item) {
    const { language, country, articlePageRoute, broadcastAreaData } = this.props;
    const { viaplayLiveStreams, viasportLiveStreams, broadcastAreaFeed, longformPrograms } = broadcastAreaData;

    switch (item) {
    case 'ViaplayLiveFeed':
      return <ViaplayLiveFeed liveStreams={viaplayLiveStreams} language={language} country={country} key={item} />;
    case 'ViasportLiveFeed':
      return <ViasportLiveFeed liveStreams={viasportLiveStreams} language={language} country={country} articlePageRoute={articlePageRoute} key={item} />;
    case 'BroadcastAreaFeed':
      return <BroadcastAreaFeed contentContainers={broadcastAreaFeed} key={item} />;
    default:
      return null;
    }
  }

  render() {
    const { broadcastAreaData } = this.props;

    const pageTemplate = _.find(broadcastAreaData.selectedTemplates, item => item.page === `${this.props.country}.broadcastarea`);
    const template = pageTemplate ? _.last(pageTemplate.template.split('.')) : null;
    const selectedTemplate = pageTemplate && template ? template : 'one';

    const broadcastAreaItems = _.get(templates, selectedTemplate);

    return (
      <div className="broadcast-area">
      {
        _.map(broadcastAreaItems, item => this.getItems(item))
      }
      </div>
    );
  }
}

BroadcastArea.propTypes = {
  language: React.PropTypes.string,
  country: React.PropTypes.string,
  articlePageRoute: React.PropTypes.object,
  broadcastAreaFeed: React.PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/component/Sidebar/BroadcastArea.jsx